import React, { useContext } from 'react'
import { SettingTab } from '@/components/molecules/settings/setting-tab'
import { AccountContext } from '@/contexts/account'
import type { AccountContextValue } from '@/contexts/account'
import { hasReservationTaskPlugin } from '@/libs/plugins'

type TabProps = {
  currentTab: 'marketSegment' | 'channelCode' | 'planName' | 'taskManagement'
}

const RESERVATION_TABS = [
  { key: 'channelCode' as const, path: '/setting/reservation/channel-code', name: 'Channel' },
  { key: 'planName' as const, path: '/setting/reservation/plan', name: 'Plan name' },
  { key: 'marketSegment' as const, path: '/setting/reservation/market-segment', name: 'Segment' },
  { key: 'taskManagement' as const, path: '/setting/reservation/task-management', name: 'reservationTaskSetting.TabName' },
]

export const SettingReservationTab: React.FC<TabProps> = ({ currentTab }) => {
  const { plugins } = useContext<AccountContextValue>(AccountContext)
  const tabs = RESERVATION_TABS.filter(tab => tab.key !== 'taskManagement' || hasReservationTaskPlugin(plugins))
  const current = RESERVATION_TABS.find(tab => tab.key === currentTab) ?? RESERVATION_TABS[0]

  return <SettingTab currentTab={current.name} tabs={tabs.map(({ path, name }) => ({ path, name }))} />
}
